import { Extension } from '@tiptap/core';
import { Plugin } from '@tiptap/pm/state';

type TableCellFinishEditTiptapExtensionOptions = {
    onCommitEdit: (event: KeyboardEvent) => void;
    onCancelEdit: (event: KeyboardEvent) => void;
};

const TableCellFinishEditTiptapExtension = Extension.create<TableCellFinishEditTiptapExtensionOptions>({
    name: 'tableCellFinishEdit',

    addOptions() {
        return {
            onCommitEdit: () => {},
            onCancelEdit: () => {},
        };
    },

    addProseMirrorPlugins() {
        return [
            new Plugin({
                props: {
                    handleKeyDown: (_view, event) => {
                        // iPad handles line breaks as a synthetic (non-keyboard) event rather than Shift+Enter, which can bypass
                        // the modifier-key checks and trigger finish-editing. Only allowing real KeyboardEvents through fixes this
                        // (a normal iPad Enter is still a KeyboardEvent).
                        if (!(event instanceof KeyboardEvent)) return false;

                        if (event.isComposing || event.shiftKey || event.altKey || event.ctrlKey || event.metaKey) {
                            return false;
                        }

                        if (event.key === 'Enter') {
                            // Suppress default enter key behaviour, and return control to the table cell editor
                            // to handle the save-and-finish flow (ie finish editing and move selection).
                            event.preventDefault();
                            event.stopPropagation();
                            event.stopImmediatePropagation();
                            this.options.onCommitEdit(event);

                            return true;
                        }

                        if (event.key === 'Escape') {
                            event.preventDefault();
                            event.stopPropagation();
                            event.stopImmediatePropagation();
                            this.options.onCancelEdit(event);

                            return true;
                        }

                        return false;
                    },
                },
            }),
        ];
    },
});

export default TableCellFinishEditTiptapExtension;
